export default __webpack_public_path__ + "static/media/223.52a2041f.jpg";